module.exports = __webpack_public_path__ + "image/login1.png";